
import { Component, Vue } from 'vue-property-decorator'
import eventHub from '@/lib/eventHub'

@Component({
})
export default class ActionButtons extends Vue {
  onResetCameraClick () {
    eventHub.$emit('reset-camera')
  }
}
